import * as React from "react";
import { ToastContainer, ToastMessageAnimated } from "react-toastr";


interface IToastProps {
    ref: Toast;
}

/** A thin wrapper around react-toastr with some default options. */
class Toast extends React.Component {

    private messageOptions: any = {
        showAnimation: "animated fadeIn",
        hideAnimation: "animated fadeOut"
    };

    private toastContainer: ToastContainer | null;

    constructor(props: IToastProps) {
        super(props);
    }

    public render() {
        return (
            <ToastContainer
                ref={ref => this.toastContainer = ref}
                className="toast-top-right"
                toastMessageFactory={React.createFactory(ToastMessageAnimated)} />
        );
    }

    public success(message: React.ReactNode | string, title?: React.ReactNode | string, overrideOptions?: any) {
        if (this.toastContainer) {
            this.toastContainer.success(message, title, { ...this.messageOptions, ...overrideOptions });
        }
    }

    public info(message: React.ReactNode | string, title?: React.ReactNode | string, overrideOptions?: any) {
        if (this.toastContainer) {
            this.toastContainer.info(message, title, { ...this.messageOptions, ...overrideOptions });
        }
    }

    public warning(message: React.ReactNode | string, title?: React.ReactNode | string, overrideOptions?: any) {
        if (this.toastContainer) {
            this.toastContainer.warning(message, title, { ...this.messageOptions, ...overrideOptions });
        }
    }

    public error(message: React.ReactNode | string, title?: React.ReactNode | string, overrideOptions?: any) {
        if (this.toastContainer) {
            this.toastContainer.error(message, title, { ...this.messageOptions, ...overrideOptions });
        }
    }
}

export default Toast;



// WEBPACK FOOTER //
// ./src/core/Toast/Toast.tsx